export default __webpack_public_path__ + "static/media/ally.16e21b8a.svg";